import { render } from "./ImgDevice2.vue?vue&type=template&id=188d552b&scoped=true"
import script from "./ImgDevice2.vue?vue&type=script&lang=js"
export * from "./ImgDevice2.vue?vue&type=script&lang=js"

import "./ImgDevice2.vue?vue&type=style&index=0&id=188d552b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188d552b"]])

export default __exports__